import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var SignHashtagSvg = function SignHashtagSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m9.161 2-.917 5.244H4.227V8.68h3.765L6.83 15.32H2.5v1.436h4.08l-.873 4.987 1.36.257.917-5.244h6.368l-.873 4.987 1.36.257.918-5.244h4.016V15.32h-3.765l1.162-6.64h4.33V7.244h-4.08l.874-4.987L16.934 2l-.918 5.244H9.648l.873-4.987zm5.442 13.32 1.162-6.64H9.397l-1.162 6.64z",
    clipRule: "evenodd"
  }));
};
export var SignHashtag = function SignHashtag(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: SignHashtagSvg
  }));
};